<template>
    <div class="c-o-search-header">
        <div class="c-o-search-header__inner">
            <div class="c-o-search-header__block">
                <h1 class="c-o-search-header__title">Sök förfrågan</h1>
                <p class="c-o-search-header__body">{{ information }}</p>
            </div>
            <div class="c-o-search-header__block">
                <div class="c-o-search-header__search">
                    <atom-input-search
                        :label="'Sök efter förfrågningar'"
                        :name="'request-search'"
                        :placeholder="'Ex. takarbeten'"
                        :searchFunction="searchFunc"
                        v-model="queryString"
                    ></atom-input-search>
                </div>
            </div>
        </div>
        <div class="c-o-search-header__meta">
            <p>Antal resultat: {{nrOfRequests}} st</p>
            <button-atom
                :icon="'reset'"
                :label="'Återställ alla val'"
                :modifiers="'c-a-button--small c-a-button--theme-gray'"
                @buttonClicked="reset"
            >
            </button-atom>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import {
        FETCH_REQUESTS,
        GET_REQUESTS,
        SET_QUERY_ACTION,
        GET_PAGE,
        IS_LOADING,
        GET_ERROR,
        RESET_SEARCH_ACTION,
        GET_SEARCH_PARAMS }
        from '../../../../store/store-models/requests-model';

    import AtomInputSearch from '../../atoms/form/AtomInputSearch.vue';
    import ButtonAtom from '../../atoms/AtomButton.vue';
    import Icon from '../../atoms/AtomIcon.vue';

    export default {
        components: {
            AtomInputSearch,
            ButtonAtom,
            Icon,
        },
        data() {
            return {
                information: 'Här kan du söka och titta alla förfrågningar som kommit in till brabyggare.se.',
            }
        },
        computed: {
            ...mapGetters({
                requests: GET_REQUESTS,
                currentPage: GET_PAGE,
                isLoading: IS_LOADING,
                error: GET_ERROR,
                searchParams: GET_SEARCH_PARAMS,
            }),
            nrOfRequests: function() {
                return !this.isLoading ? this.requests.meta.count : 0
            },
            queryString: {
                get() {
                    return this.searchParams.q;
                },
                set(val) {
                    this.setQuery(val);
                }
            }
        },
        methods: {
            ...mapActions({
                fetchRequests: FETCH_REQUESTS,
                setQuery: SET_QUERY_ACTION,
                resetSearch: RESET_SEARCH_ACTION
            }),
            searchFunc() {
                this.fetchRequests();
            },
            reset() {
                this.resetSearch();
                this.fetchRequests();
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/components/organisms/search/OrganismSearchHeaderRequests.vue